import {ENTER} from '@angular/cdk/keycodes';
import {Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatAutocompleteSelectedEvent, MatChipInputEvent} from '@angular/material';
import {Observable} from 'rxjs/Observable';
import {map, startWith} from 'rxjs/operators';
import {Utilities} from '@shared/utilities/utilities.model';

@Component({
	selector: 'amd-chips',
	templateUrl: './chips.component.html',
	styleUrls: ['./chips.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class ChipsComponent implements OnInit {

	@Input() visible: boolean;
	@Input() selectable: boolean;
	@Input() removable: boolean;
	@Input() addOnBlur: boolean;
	@Input() placeholder: string;
	@Input() addPersonalItems: boolean;
	@Input() items: string[] = [];
	@Input() allItems: string[];
	@Input() itemCtrl: FormControl;

	separatorKeysCodes = [ENTER];
	filteredItems: Observable<any[]>;

	@ViewChild('itemInput') itemInput: ElementRef;

	constructor() {
	}

	ngOnInit() {

        if( this.items && this.allItems) {
            this.filteredItems = (this.itemCtrl as FormControl).valueChanges.pipe(
                startWith(null),
                map((item: string | null) => item ? this.filter(item) : this.allItems.slice()));
        }
	}

	add(event: MatChipInputEvent): void {
		const input: HTMLInputElement = event.input;
		const value: string = event.value;
		let isCheckedOK = true;

		if (!this.addPersonalItems && !this.allItems.includes(value)) {
			isCheckedOK = false;
			input.value = '';
		}
		if (isCheckedOK) {
			/** add my item**/
			if ((value || '').trim() && !this.items.includes(value) && !Utilities.isVoid(value)) {
				this.items.push(value.trim());
			}
			/** Reset the input value **/
			if (input) {
				input.value = '';
			}
			this.itemCtrl.setValue(null);
		}
	}

	remove(item: any): void {
		const index = this.items.indexOf(item);

		if (index >= 0) {
			this.items.splice(index, 1);
		}
	}

	filter(name: string) {
		return this.allItems.filter(item => !Utilities.isVoid(item)).filter(item =>
		item.toLowerCase().indexOf(name.toLowerCase()) === 0);
	}

	selected(event: MatAutocompleteSelectedEvent): void {
		if (!this.items.includes(event.option.viewValue)) {
			this.items.push(event.option.viewValue);
		}
		this.itemInput.nativeElement.value = '';
		this.itemCtrl.setValue(null);
	}
}
